import React from "react";
import Checkbox from "./checkbox";

type SelectAccountProps = {
    id: string,
    account: any,
    onChange: any
}

const SelectAccount = (props: SelectAccountProps) => {
    const { id, account, onChange } = props;

    const handleChange = (e: any) => {
        account["isSelected"] = e;
        onChange();
    }

    const selectCheckbox = (id: string) => (document.getElementById(id) as HTMLElement).click();

    return (
        <li key={id}>
            <Checkbox id={id} onChange={handleChange} initialState={account.isSelected} />

            <label onClick={e => selectCheckbox(id)}>
                <p>
                    <strong>{account.name}</strong>
                </p>

                <p>
                    <em>Address:</em>&nbsp;{account.address?.join(", ")}
                </p>

                {/* //TODO: check for existence */}
                <p>
                    <em>Customer Number:</em> {account.customerNumber}<br />

                    <em>Contact Person:</em> {account.contactName}<br />

                    <em>Email:</em> {account.contactEmail}
                </p>
            </label>
        </li>
    )
}

export default SelectAccount;
